<template>
  <div class="ml-2">
      <div v-for="val in webPageValue" :key="val.nodeID">
          <button class="btn btn-block text-left collapsed" type="button"
              @click="toggleAccordion(val.nodeID)">
              <span class="w-100 text-capitalize font-weight-lighter"
                  @click="val.pageUrl != '' && val.pageUrl != '#' && selectTheWebPage(val)">{{ val.pageName.toLowerCase() }}</span>
              <span :class="{'png-icon png-icon-icons-glyph--k-chevron-up': isExpanded(val.nodeID), 'png-icon png-icon-icons-glyph--k-chevron-down': !isExpanded(val.nodeID)}" v-if="val.children.length > 0"></span>
          </button>

          <div :id="'collapseCard' + val.nodeID" class="collapse text-capitalize"
              :class="{ 'show': isExpanded(val.nodeID) }">
              <Accordion-Children v-if="val.children.length > 0" :webPageValue="val.children"
                :setShowAllWebPages="setShowAllWebPages" />
          </div>
      </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import AccordionChildren from "./accordion-children.vue";
export default {
  props: ["webPageValue", "setShowAllWebPages"],
  name: "Accordion-Children",
  components: {
      AccordionChildren
  },
  data() {
      return {
          expandedItems: []
      };
  },
  methods: {
      ...mapActions({
          selectWebPage: "contentWizard/selectWebPage",
      }),
      toggleAccordion(nodeID) {
          const index = this.expandedItems.indexOf(nodeID);
          if (index === -1) {
              this.expandedItems.push(nodeID);
          } else {
              this.expandedItems.splice(index, 1);
          }
      },
      isExpanded(nodeID) {
          return this.expandedItems.includes(nodeID);
      },
      selectTheWebPage(data) {
          this.selectWebPage(data);
          this.setShowAllWebPages(false);
      },
  }
}
</script>
